import axios from "axios";

const API_URL = "https://chatbot-rmfs.onrender.com";

export async function askChatbot(question) {
  try {
    // Cambiamos a POST y enviamos un cuerpo con el campo 'prompt'
    const response = await axios.post(
      `${API_URL}/ask`,
      { prompt: question },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data.response;
  } catch (error) {
    console.error("Error al llamar al chatbot:", error);
    if (error.response && error.response.data && error.response.data.detail) {
      console.error("Detalle del error:", error.response.data.detail[0]);
    }
    throw error;
  }
}
